"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GVPDemo_1 = require("./GVPDemo");
exports.default = GVPDemo_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/GVP/GVPDemo/index.js
// module id = 1026
// module chunks = 8